import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaBookOpen, FaChalkboardTeacher, FaWhatsapp } from 'react-icons/fa';
import styles from './pagina_nutri_marimurra.module.scss';
import Foto from './src/foto2.jpg';
import { WHATSAPP_ONLINE, getWhatsappUrl } from './dados_nutri_marimurra.ts';

const MATERIAIS = [
    {
        titulo: 'Cursos e e-books',
        status: 'Em desenvolvimento',
        descricao:
            'Os primeiros cursos e e-books estão sendo preparados com muito carinho e em breve estarão disponíveis aqui.',
        icon: <FaBookOpen />,
    },
    {
        titulo: 'Aulas',
        status: 'Em breve',
        descricao:
            'Aulas sobre alimentação infantil e seletividade alimentar. As próximas datas serão divulgadas por aqui.',
        icon: <FaChalkboardTeacher />,
    },
];

const Cursos_nutri_marimurra: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pagina_nutri_marimurra}>
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/nutri_marimurra" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <img className={styles.heroImg} src={Foto} alt="Mariana Murra, nutricionista" />

                <p className={styles.eyebrow}>Aprenda comigo</p>
                <h1 className={styles.title}>Cursos e materiais</h1>
                <p className={styles.lead}>
                    Conteúdos com base científica para ajudar famílias e profissionais a construírem uma relação
                    mais leve com a alimentação das crianças.
                </p>

                <div className={styles.section}>
                    <div className={styles.itemList}>
                        {MATERIAIS.map((item) => (
                            <div key={item.titulo} className={styles.item}>
                                <span className={styles.itemIcon}>{item.icon}</span>
                                <div>
                                    <span className={styles.badge}>{item.status}</span>
                                    <h2 className={styles.itemTitle}>{item.titulo}</h2>
                                    <p className={styles.paragraph}>{item.descricao}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Quer ser avisado(a) do lançamento?</h2>
                    <p className={styles.paragraph}>Mande uma mensagem e receba as novidades em primeira mão.</p>
                    <div className={styles.ctaButtons}>
                        <a
                            href={getWhatsappUrl(
                                WHATSAPP_ONLINE,
                                'Olá, Mariana! Gostaria de ser avisado(a) quando os cursos e materiais forem lançados.'
                            )}
                            className={`${styles.button} ${styles.buttonLight}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp aria-hidden />
                            Quero ser avisado(a)
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cursos_nutri_marimurra;
